import { DatePicker, message } from "antd";
import dayjs from "dayjs";
import { useCallback } from "react";
const FORMAT = "MM-DD-YYYY";
export default function StrictDatePicker({ value, onChange, ...props }) {
  const validateAndSet = useCallback(
    (text) => {
      if (!text) {
        message.warning("Please enter a valid date in MM-DD-YYYY format");
        return;
      }
   const regex =
        /^(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])-\d{4}$/;
   if (!regex.test(text)) {
        message.warning("Date must be in MM-DD-YYYY format");
        return;
      }
    const parsed = dayjs(text, FORMAT, true);
    if (!parsed.isValid()) {
        message.warning("Invalid date");
        return;
      }
   onChange?.(parsed);
    },
    [onChange]
  );
const handleChange = (date, dateString) => {
    if (date) {
      onChange?.(date);
      return;
    }
   validateAndSet(dateString);
  };

  return (
    <DatePicker
      value={value}
      format={FORMAT}
      inputReadOnly={false}
      onChange={handleChange}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          validateAndSet(e.target.value);
        }
      }}
      {...props}
    />
  );
}